module.exports = Object.freeze({
    UNDER_MAINTENANCE_FLAG: 'under maintenance',
    CONNECTION_ISSUE_FLAG: 'connection issue',
    SHOP_CLOSED_WITH_ORDERS_FLAG: 'shop closed',
    EMPTY_HEADER_FLAG: 'empty',
    UNDER_MAINTENANCE_ALERT: {
        title: 'We’re temporarily closed',
        desc: 'If you’re still waiting for an order, check out the active orders below.'
    },
    SHOP_CLOSED_WITH_ORDERS_ALERT: {
        title: 'We’re  closed',
        desc: 'If you’re still waiting for an order, check out the active orders below.',
        showOpenHours: true
    },
    CONNECTION_ISSUE_ALERT: {
        title: 'We’ve lost connection',
        desc: 'We will show the updated line once the connection is restored.',
    },
    HALL_PAGE: 'hall',
    SHOP_PAGE: 'shop',
    TAPINGO: 1,
    GRUBHUB: 2,
    SEAMLESS: 3,
    LOCALSTORAGE_BRAND_ID_KEY: 'brand_id',
});



// WEBPACK FOOTER //
// ./src/constants/Texts.js